export default __webpack_public_path__ + "static/media/431.20b22a3e.png";